import { EmployeeInfo } from '@/types/session'
import { create } from 'zustand'

interface AuthStore {
    employee: EmployeeInfo | null
    setEmployee: (employee: EmployeeInfo | null) => void
}

const useAuthStore = create<AuthStore>((set) => ({
    employee: null,
    setEmployee: (employee: EmployeeInfo | null) => set({ employee }),
}))

export default useAuthStore
